import { useContext, useEffect, useState } from "react";
import ContentSection from "../Content";
import { UserContext } from "../../utils/User_check";
import can from '../../utils/Can';
import ApexCharts from 'apexcharts';
import Chart from "react-apexcharts";
import axios from "axios";
import BaseUrl from "../../utils/BaseUrl";
import CustomerStyle from "../../utils/customerStyle";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import moment from "moment";
import separateNumber from "../../utils/separateur";

const url = BaseUrl();
const customerStyle = CustomerStyle();

function DashboardPage(){
    const {user,permissions} = useContext(UserContext);
    const [totalDemande,setTotalDemande] = useState(0);
    const [totalContratIn,setTotalContratIn] = useState(0);
    const [totalDemandeEnAttente,setTotalDemandeEnAttente] = useState(0);
    const [totalIntervention,setTotalIntervention] = useState(0);

    const [demandeSerie,setDemandeSerie] = useState({series: [], labels: []});

    const [interventionSerie,setInterventionSerie] = useState({series: [], labels: []});
    const [loading,setLoading] = useState(false);


  
    useEffect(()=>{
        if(!can(permissions,'dashboard')){

        }
        fetchDataSynthese();
    },[]);


    const fetchDataSynthese = async ()=>{
        setLoading(true);
        try {
            axios.get(url.base+'/statistique-dashboard-asset',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
    
                if(resp.status == 200){
                  setTotalDemande(resp.data?.totalMateriel);
                  setTotalContratIn(resp.data?.totalContratEncours);
                  setTotalDemandeEnAttente(resp.data?.totalDemandeEnAttente);
                  setTotalIntervention(resp.data?.totalIntervention);

    
                    const labelMoisArr = Object.keys(resp.data.labels).map(key => resp.data?.labels[key]);
                    // console.log(resp.data?.demandeParStatutLables);
                    console.log(resp.data);
                    setDemandeSerie({
                      series:Object.values(resp.data?.demandeSerie),
                      labels: labelMoisArr?.map((label)=>label),
                    })
                    setInterventionSerie({
                      series:Object.values(resp.data?.interventionSerie),
                      labels:labelMoisArr.map((label)=>label),
                    });


    
                }
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }
          
    const state = {
        series: [
            {
              name: "Demandes",
              data: demandeSerie?.series?.map((serie)=>serie)
            },
            {
              name: "Intervention",
              data: interventionSerie?.series?.map((serie)=>serie)
            }
          ],
          options: {
            chart: {
              height: 350,
              type: 'line',
              dropShadow: {
                enabled: true,
                color: '#000',
                top: 18,
                left: 7,
                blur: 10,
                opacity: 0.2
              },
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false
              }
            },
            colors: ['#77B6EA', '#545454'],
            dataLabels: {
              enabled: true,
            },
            stroke: {
              curve: 'smooth'
            },
            title: {
              text: 'DEMANDES & INTERVENTION',
              align: 'left'
            },
            grid: {
              borderColor: '#e7e7e7',
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            markers: {
              size: 1
            },
            xaxis: {
              categories:demandeSerie?.labels,
              title: {
                text: 'Mois'
              }
            },
            yaxis: {
              title: {
                text: ''
              },
              min: 5,
              max: 40
            },
            legend: {
              position: 'top',
              horizontalAlign: 'right',
              floating: true,
              offsetY: -25,
              offsetX: -5
            }
          },
        
        
    };



    return (
        <>
            <ContentSection navactive={""} ulShownav={""}>
           
                    <div className="pt-10 pb-21 mt-n6 mx-n4"></div>
                    <div className="container-fluid mt-n22 ">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                
                                <div className="d-flex justify-content-between align-items-center mb-5">
                                    <div className="mb-2 mb-lg-0">
                                        <h3 className="mb-0  text-dark">Tableau de bord</h3>
                                    </div>
                                    {/* <div>
                                        <a href="#!" className="btn btn-white">Create New Project</a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        {can(permissions,"dashboard") &&
                            <>
                                 <div className="row">
                            <div className="col-xl-3 col-lg-6 col-md-12 col-12 mb-5">
                                
                                <div className="card h-100 card-lift">
                                    
                                    <div className="card-body">
                                        
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h4 className="mb-0">Asset total deployé</h4>
                                            </div>
                                            <div className="icon-shape icon-md bg-primary-soft text-primary rounded-2">
                                                <i  data-feather="briefcase" height="20" width="20"></i>
                                            </div>
                                        </div>
                                    
                                        <div className="lh-1">
                                            <h1 className=" mb-1 fw-bold text-success">{totalDemande}</h1>
                                            {/* <p className="mb-0"><span className="text-dark me-2">2</span></p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-12 col-12 mb-5">
                                
                                <div className="card h-100 card-lift">
                                    
                                    <div className="card-body">
                                        
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h4 className="mb-0">Demandes Assets Total Reçus</h4>
                                            </div>
                                            <div className="icon-shape icon-md bg-primary-soft text-primary rounded-2">
                                                <i  data-feather="list" height="20" width="20"></i>
                                            </div>
                                        </div>
                                    
                                        <div className="lh-1">
                                            <h1 className="  mb-1 fw-bold">{totalContratIn}</h1>
                                            {/* <p className="mb-0"><span className="text-dark me-2">28</span>Completed</p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-12 col-12 mb-5">
                                
                                <div className="card h-100 card-lift">
                                    
                                    <div className="card-body">
                                        
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h4 className="mb-0">Demande Intervention Total Reçus</h4>
                                            </div>
                                            <div className="icon-shape icon-md bg-primary-soft text-primary rounded-2">
                                                    <i  data-feather="users" height="20" width="20"></i>
                                            </div>
                                        </div>
                                    
                                        <div className="lh-1">
                                            <h1 className="  mb-1 fw-bold">{totalDemandeEnAttente}</h1>
                                            {/* <p className="mb-0"><span className="text-dark me-2">1</span>Completed</p> */}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-12 col-12 mb-5">
                                
                                <div className="card h-100 card-lift">
                                    
                                    <div className="card-body">
                                        
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h4 className="mb-0">Total depensée en demande d'intervention</h4>
                                            </div>
                                            <div className="icon-shape icon-md bg-primary-soft text-primary rounded-2">
                                                    <i  data-feather="target" height="20" width="20"></i>
                                            </div>
                                        </div>
                                    
                                        <div className="lh-1">
                                            <h1 className="  mb-1 fw-bold text-danger">{separateNumber(totalIntervention) } FCFA</h1>
                                            {/* <p className="mb-0"><span className="text-success me-2">5%</span>Completed</p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                       
                        
                        <div className="row ">
                            <div className="col-xl-12 col-12 mb-5">
                                
                                <div className="card">
                                    
                                    <div className="card-header ">
                                        <h4 className="mb-0">Statistique</h4>
                                    </div>
                                    
                                    <div className="card-body">
                                    <div className="table-responsive table-card">
                                      {!loading &&
                                        <Chart
                                            options={state?.options}
                                            series={state?.series}
                                            type="line"
                                            height={350}
                                        />
                                      }
                                    
                                    </div>
                                </div>
                                    
                   
                                </div>

                            </div>
                          
                        </div> 
                        
            
          

                    </>
                        }
                    </div>
                
            </ContentSection>
            
        </>
    )
}

export default DashboardPage;